<div class="">
  <div *ngIf="caso" class="container2">
    <!-- <app-case-information
      [canRequestRevision]="canRequestRevision"
      (reload)="init()"
    ></app-case-information> -->

    <div class="actions">
      <mat-checkbox class="custom-checkbox" (change)="requeridoChange()"
        >Mostrar Tareas Requeridas</mat-checkbox
      >
    </div>

    <div class="row mt-4" cdkDropListGroup>
      <div class="col-4 mt-4">
        <div class="tarea">
          <div class="tarea-header" style="background-color: #f9f9f9">
            <div class="row">
              <p class="tarea-titulo col-10">
                Pendiente de realizar ({{ pendientePorRealizarshow.length }})
              </p>
            </div>
          </div>
          <div
            class="tarea-text"
            cdkDropList
            [cdkDropListData]="pendientePorRealizarshow"
            (cdkDropListDropped)="drop($event, 'Pendiente de realizar')"
          >
            <task-card
              *ngFor="let task of pendientePorRealizarshow"
              cdkDrag
              [task]="task"
            ></task-card>
          </div>
        </div>
      </div>
      <div class="col-4 mt-4">
        <div class="tarea">
          <div class="tarea-header" style="background-color: #eeeeee">
            <div class="row">
              <p class="tarea-titulo col-10">
                En Ejecución ({{ enEjecucionshow.length }})
              </p>
            </div>
          </div>
          <div
            class="tarea-text"
            cdkDropList
            [cdkDropListData]="enEjecucionshow"
            (cdkDropListDropped)="drop($event, 'En Ejecución')"
          >
            <task-card
              *ngFor="let task of enEjecucionshow"
              cdkDrag
              [task]="task"
              (click)="openTarea(task)"
              [clickable]="true"
            ></task-card>
          </div>
        </div>
      </div>
      <div class="col-4 mt-4">
        <div class="tarea">
          <div class="tarea-header" style="background-color: #eeeeee">
            <div class="row">
              <p class="tarea-titulo col-10">
                Finalizado ({{ finalizadoshow.length }})
              </p>
            </div>
          </div>
          <div
            class="tarea-text"
            cdkDropList
            [cdkDropListData]="finalizadoshow"
            (cdkDropListDropped)="drop($event, 'Finalizado')"
          >
            <task-card
              *ngFor="let task of finalizadoshow"
              cdkDrag
              [task]="task"
              (click)="openTarea(task)"
              [clickable]="true"
            ></task-card>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--
  <app-comentario-caso
    *ngIf="true"
    [idCaso]="idCaso"
    (closeEvent)="openComments()"
  >

  </app-comentario-caso>

  <a (click)="openComments()" class="float">
    <i class="fa fa-comment my-float"></i>
  </a> -->
</div>
